import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { request } from './http-client'
import { IAvailableTablesResponse, IReservation, IReservationsGetListResponse, ISection } from './types/reservations'

interface IAnyParams {
  params?: any;
  props?: any;
}

interface GetByIdProps {
  id: string,
  props?: any,
}

export const sectionService = {
  getList: (params: any) => request.get<{ sections: ISection[], count: number }>("/v1/sections", { params }),
}

export const reservationService = {
  getAvailableTables: async (params: any) => await request.get("v1/check-available-tables", { params }).then(res => res?.data),
  getList: async (params: any) => await request.get("v1/mika/reservations", { params }).then(res => res?.data),
  create: async (body: any) => await request.post("v1/reservation", body),
  getById: async (id: string) => await request.get(`v1/reservation/${id}`),
  update: async (id: string, body: any) => await request.put(`v1/reservation/${id}`, body),
  changeStatus: async (id: string, body: any) => await request.patch(`change-status-reservations/${id}`, body),
  getCount: async (params: any) => await request.get("/reservations-count", { params }),
}

export const useAvailableTablesList = ({ params, props }: IAnyParams) => {
  return useQuery<IAvailableTablesResponse>({
    queryKey: ["GET_AVAILABLE_TABLES", props, params],
    queryFn: () => reservationService.getAvailableTables(params),
    ...props,
  });
};

export const useSingleReservation = ({ id, props }: GetByIdProps) => {
  return useQuery<IReservation>({
    queryKey: ["GET_SINGLE_RESERVATION", id, props],
    queryFn: () => reservationService.getById(id).then(res => res?.data),
    ...props,
  });
};

export const useAllReservationsList = ({ params, props }: IAnyParams): UseQueryResult<IReservationsGetListResponse, Error> => {
  return useQuery<IReservationsGetListResponse, Error>({
    queryKey: ["GET_ALL_RESERVATIONS", props, params],
    queryFn: () => reservationService.getList(params),
    ...props,
  });
};